import { CREATE_EMPLOYEE, UPDATE_EMPLOYEE, REMOVE_EMPLOYEE, STORE_EMPLOYEES } from './../../actionTypes';

export function createEmployee(employee) {
  return {
    type: CREATE_EMPLOYEE,
    employee
  };
}

export function updateEmployee(employee) {
  return {
    type: UPDATE_EMPLOYEE,
    employee
  };
}

export function removeEmployee(employeeId) {
  return {
    type: REMOVE_EMPLOYEE,
    employeeId
  };
}

export function storeEmployees(employees) {
  return {
    type: STORE_EMPLOYEES,
    employees
  };
}




// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/employees.js